export default __webpack_public_path__ + "static/media/team60.d215d0cd.JPG";